import dayjs from 'dayjs';

const DAY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * The dates a booking page is opened with — `/rentals/listing/:id?start=YYYY-MM-DD&end=YYYY-MM-DD`,
 * the address "Book these dates" of the assistant's panel leads to (api#381). Both must be calendar
 * days in order and the first not before `today`; otherwise the form starts empty, as it always
 * did, and the calendar is the person's to pick from. The calendar stays the judge of conflicts:
 * dates that overlap a booking are shown with the same error a hand-picked pair gets.
 */
export const bookingDatesFromSearch = (
  search: URLSearchParams,
  today: string
): { startDate: string; endDate: string } => {
  const startDate = search.get('start') ?? '';
  const endDate = search.get('end') ?? '';
  const empty = { startDate: '', endDate: '' };

  if (!DAY.test(startDate) || !DAY.test(endDate)) return empty;

  const start = dayjs(startDate);
  const end = dayjs(endDate);

  if (!start.isValid() || !end.isValid()) return empty;
  if (start.format('YYYY-MM-DD') !== startDate || end.format('YYYY-MM-DD') !== endDate) return empty;
  if (!end.isAfter(start)) return empty;
  if (start.isBefore(dayjs(today))) return empty;

  return { startDate, endDate };
};

/** The address of a car's booking page with the dates filled in. */
export const bookingPathWithDates = (listingId: string, dates: { startDate: string; endDate: string }): string =>
  `/rentals/listing/${encodeURIComponent(listingId)}?start=${dates.startDate}&end=${dates.endDate}`;
